import axios from "axios";

export default async function commitObjectLater(projectName, formName, document_id, data) {
    // old api => return await axios.post(`project/${projectName}/${formName}/add-document`, data)
    return await axios.post(`/project/${projectName}/${formName}/archive-document/${document_id}/save`, data)
}